import { localizedRouteGroup } from 'routing/routes';

import { VOLOP_URL_SEGMENTS } from './volop.route-segments';

export const volopSegmentedRoutes = VOLOP_URL_SEGMENTS.map((volopUrlSegment) =>
  localizedRouteGroup.route(`${volopUrlSegment}/:volopIdDashSlug`),
);
